import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import styled from 'astroturf/react'
import _ContentWrapper from "ContentWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/layout/content_wrapper.js?styleId=ContentWrapper";


const ContentWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "ContentWrapper",
  styles: _ContentWrapper,
  attrs: props => ({
    ...props,
    isTabletUp: useDeviceType('isTabletUp')
  })
})

export default ContentWrapper
